var _linearGradient, _rect, _rect2, _g, _g2, _g3, _g4, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeasonalDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "seasonalGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A5D6A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "33%",
    stopColor: "#FFCC80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66%",
    stopColor: "#FFAB91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#90CAF9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "url(#seasonalGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 780,
    height: 180,
    rx: 5,
    fill: "none",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeDasharray: "10 5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 100)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#90CAF9",
    stroke: "#1976D2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,-30 M0,0 L0,30 M0,0 L-26,-15 M0,0 L26,15 M0,0 L-26,15 M0,0 L26,-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-20 L5,-15 L0,-10 L-5,-15 L0,-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,20 L5,15 L0,10 L-5,15 L0,20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17,-10 L-12,-5 L-17,0 L-22,-5 L-17,-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,10 L22,5 L17,0 L12,5 L17,10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17,10 L-12,5 L-17,0 L-22,5 L-17,10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,-10 L22,-5 L17,0 L12,-5 L17,-10"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#90CAF9",
    stroke: "#1976D2",
    strokeWidth: 0.5,
    transform: "translate(-40, -40) scale(0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,-20 M0,0 L0,20 M0,0 L-17,-10 M0,0 L17,10 M0,0 L-17,10 M0,0 L17,-10"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#90CAF9",
    stroke: "#1976D2",
    strokeWidth: 0.5,
    transform: "translate(-30, 30) scale(0.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,-20 M0,0 L0,20 M0,0 L-17,-10 M0,0 L17,10 M0,0 L-17,10 M0,0 L17,-10"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,30 C0,10 0,0 0,-10",
    stroke: "#4CAF50",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10 C-10,5 -15,0 -10,-5 C-5,-10 0,-5 0,0",
    fill: "#A5D6A7",
    stroke: "#4CAF50",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5 C10,0 15,-5 10,-10 C5,-15 0,-10 0,-5",
    fill: "#A5D6A7",
    stroke: "#4CAF50",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 10,
    fill: "#F48FB1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -15,
    r: 5,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: -15,
    r: 7,
    fill: "#F48FB1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -8,
    cy: -15,
    r: 7,
    fill: "#F48FB1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -23,
    r: 7,
    fill: "#F48FB1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -7,
    r: 7,
    fill: "#F48FB1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(550, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 25,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FF9800",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -35,
    x2: 0,
    y2: -40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 35,
    x2: 0,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: -35,
    y1: 0,
    x2: -40,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 0,
    x2: 40,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25,
    y1: -25,
    x2: -30,
    y2: -30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: -25,
    x2: 30,
    y2: -30
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25,
    y1: 25,
    x2: -30,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 25,
    x2: 30,
    y2: 30
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C-10,-15 -25,-10 -20,5 C-15,15 0,10 0,0 Z",
    fill: "#FF7043",
    stroke: "#E64A19",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C10,-15 25,-10 20,5 C15,15 0,10 0,0 Z",
    fill: "#FFB74D",
    stroke: "#EF6C00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C-10,15 -25,10 -20,-5 C-15,-15 0,-10 0,0 Z",
    fill: "#FFAB91",
    stroke: "#E64A19",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C10,15 25,10 20,-5 C15,-15 0,-10 0,0 Z",
    fill: "#FFA726",
    stroke: "#EF6C00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3,
    fill: "#795548"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 70,
    fontFamily: "Arial, sans-serif",
    fontSize: 35,
    fontWeight: "bold",
    fill: "#263238",
    textAnchor: "middle"
  }, "SEASONAL DISCOUNT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 110,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#263238",
    textAnchor: "middle"
  }, "20% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 140,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#37474F",
    textAnchor: "middle"
  }, "Special savings for this season only")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeasonalDiscount);
export default __webpack_public_path__ + "static/media/seasonal_discount.37268cf2eac4e3e21b21068b9724d929.svg";
export { ForwardRef as ReactComponent };